import resolveColor from "@insite/mobius/utilities/resolveColor";
import { BlockBaseProps, BlockBorderProps } from "@tCentro/Components/Common/Block/Block";
import { defaultBorderProps } from "@tCentro/Components/Common/Block/defaultProps";
import { BlockVariantBaseProps, BlockVariantSide } from "@tCentro/Components/Common/Block/variant/base";
import { getVariantBorderProps } from "@tCentro/Components/Common/Block/variant/utilities";
import { clearfixStyles } from "@tCentro/theme/mixins";
import { css } from "styled-components";

export interface BlockVariantBorderedBaseProps {
    border?: BlockBorderProps;
}
export interface BlockVariantBorderedProps extends BlockVariantBaseProps, BlockVariantBorderedBaseProps {}

const defaultProps: BlockVariantBorderedProps = {
    border: defaultBorderProps,
};

const staticProps: BlockVariantBaseProps = {
    containerCss: css<BlockBaseProps>`
        ${clearfixStyles()}

        ${({ theme, variantProps, variantSide }) => {
            const { width, type, color } = getVariantBorderProps(variantProps?.bordered);

            const _topStyles = css`
                border-top: ${width} ${type} ${resolveColor(color, theme)};
            `;
            const _bottomStyles = css`
                border-bottom: ${width} ${type} ${resolveColor(color, theme)};
            `;

            switch (variantSide) {
                case BlockVariantSide.Top:
                    return _topStyles;
                case BlockVariantSide.Bottom:
                    return _bottomStyles;
                default:
                    return css`
                        ${_topStyles} ${_bottomStyles}
                    `;
            }
        }}
    `,
};

export default { defaultProps, staticProps };
